(function () {
  var SECTION_ID = 'cart-drawer';

  function drawer() { return document.querySelector('[data-cart-drawer]'); }
  function content() { return document.getElementById('CartDrawerContent'); }

  function openCart() {
    var d = drawer();
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
    var panel = d.querySelector('.cart-drawer__panel');
    if (panel) panel.focus();
  }

  function closeCart() {
    var d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  }

  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? ' (' + count + ')' : '';
    });
  }

  function renderDrawer(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('CartDrawerContent');
    var current = content();
    if (fresh && current) {
      current.innerHTML = fresh.innerHTML;
      current.setAttribute('data-item-count', fresh.getAttribute('data-item-count'));
      updateCount(parseInt(fresh.getAttribute('data-item-count'), 10) || 0);
    }
  }

  function refreshDrawer() {
    return fetch(window.location.pathname + '?sections=' + SECTION_ID)
      .then(function (r) { return r.json(); })
      .then(function (data) { renderDrawer(data[SECTION_ID]); });
  }

  function changeLine(line, quantity) {
    var c = content();
    if (c) c.classList.add('is-loading');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: SECTION_ID })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.sections) renderDrawer(data.sections[SECTION_ID]);
        else return refreshDrawer();
      })
      .catch(function () { window.location.href = '/cart'; })
      .finally(function () { var c2 = content(); if (c2) c2.classList.remove('is-loading'); });
  }

  function showFormError(form, message) {
    var el = form.querySelector('[data-cart-error]');
    if (!el) {
      el = document.createElement('p');
      el.setAttribute('data-cart-error', '');
      el.className = 'glacier-form-error';
      form.appendChild(el);
    }
    el.textContent = message;
  }

  function handleAddToCart(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (!drawer() || !window.fetch) return;
    event.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var label = button ? button.innerHTML : '';
    if (button) { button.disabled = true; button.innerHTML = 'Adding...'; }
    var errorEl = form.querySelector('[data-cart-error]');
    if (errorEl) errorEl.textContent = '';

    var formData = new FormData(form);
    formData.append('sections', SECTION_ID);
    formData.append('sections_url', window.location.pathname);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          showFormError(form, res.data.description || res.data.message || 'Could not add to cart.');
          return;
        }
        if (res.data.sections && res.data.sections[SECTION_ID]) {
          renderDrawer(res.data.sections[SECTION_ID]);
          openCart();
        } else {
          return refreshDrawer().then(openCart);
        }
      })
      .catch(function () { form.submit(); })
      .finally(function () {
        if (button) { button.disabled = false; button.innerHTML = label; }
      });
  }

  document.addEventListener('submit', handleAddToCart);

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-cart-toggle]');
    if (toggle && drawer()) {
      event.preventDefault();
      openCart();
      return;
    }
    if (event.target.closest('[data-cart-close]')) {
      event.preventDefault();
      closeCart();
      return;
    }
    var qtyBtn = event.target.closest('[data-cart-line]');
    if (qtyBtn) {
      event.preventDefault();
      changeLine(parseInt(qtyBtn.getAttribute('data-cart-line'), 10), parseInt(qtyBtn.getAttribute('data-cart-qty'), 10));
    }
  });

  // Bundle picker (product page): sync quantity + button price with the chosen bundle
  document.addEventListener('change', function (event) {
    var input = event.target;
    var picker = input.closest && input.closest('[data-bundle-picker]');
    if (!picker) return;
    picker.querySelectorAll('.glacier-bundle').forEach(function (label) {
      label.classList.toggle('is-selected', label.contains(input));
    });
    var scope = picker.parentElement;
    var qty = scope.querySelector('[data-bundle-qty]');
    var price = scope.querySelector('[data-bundle-button-price]');
    if (qty) qty.value = input.value;
    if (price) price.textContent = input.getAttribute('data-bundle-total');
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeCart();
  });

  // Cart page: auto-submit quantity changes
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.glacier-cart__qty').forEach(function (input) {
      input.addEventListener('change', function () {
        input.closest('form').submit();
      });
    });
  });

  // Keep drawer in sync if the page is restored from the back/forward cache
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && drawer()) refreshDrawer();
  });

  window.GlacierCart = { open: openCart, close: closeCart, refresh: refreshDrawer };
})();
